import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

export default function Layout({ children }) {
  return (
    <div className="relative min-h-screen bg-[#030303]">
      <div className="noise-layer" aria-hidden="true" />
      <Navbar />
      <main className="relative z-10">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
